<template>
  <div>
    <v-container fluid ref="table_container">
      <v-row no-gutters>
        <v-col cols="8" v-if="internalViewDef.viewType === 'similarity' && !internalViewDef.showSimilarityTitleRow">
          <span v-html="getMatchDescription(null)"> </span>
        </v-col>
        <v-col class="mb-4">
          <v-btn
            v-if="allowDesigner"
            elevation="0"
            class="ml-3 rm-button-icon float-right"
            title="Report Designer"
            @click="$emit('showDesigner')"
            ><v-icon small>mdi-tools</v-icon></v-btn
          ><v-btn
            v-if="allowMaximise"
            @click="$emit('maximise')"
            :title="maximised ? 'Restore View Area' : 'Expand View Area'"
            elevation="0"
            class="ml-3 rm-button-icon float-right"
            ><v-icon small>{{
              maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand"
            }}</v-icon></v-btn
          >
          <v-badge
            v-if="selectedDocs.length"
            color="green"
            class="float-right"
            left
            overlap
            :content="selectedDocs.length"
          >
            <v-btn
              class="rm-button"
              @click="compareDocDetailsFull"
              elevation="0"
            >
              <v-icon>mdi-compare</v-icon> Compare
              <v-divider class="ml-3" vertical></v-divider
              ><v-icon
                class="ml-3"
                title="Clear Selected Documents"
                @click.stop="resetCompare"
                >mdi-close-box-outline</v-icon
              ></v-btn
            ><v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-2 rm-button"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                >
                  Actions <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="compareDocDetailsFull">
                  <v-list-item-title>Full compare view</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="editDocs()">
                          <v-list-item-title>Bulk Edit</v-list-item-title>
                        </v-list-item> -->
                <!-- <v-list-item
                  @click="compareDocDetails"
                  :disabled="selectedDocs.length > 15"
                >
                  <v-list-item-title>Side-by-side view</v-list-item-title>
                </v-list-item> -->
                <v-list-item
                  v-if="usesTags"
                  @click="getDocumentTags(selectedDocs)"
                >
                  <v-list-item-title>{{
                    (tagsDialogue.subject || "Skill") + " Comparison"
                  }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="openDocListMenu($event)">
                          <v-list-item-title>List Selected Documents</v-list-item-title>
                        </v-list-item> -->
                <v-list-item @click="resetCompare">
                  <v-list-item-title
                    >Clear Selected Documents</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-badge>
          <template v-else
            ><v-btn class="ml-2 rm-button float-right" elevation="0" disabled>
              Actions <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
            <v-btn
              disabled
              color="#eeeeee"
              class="rm-button float-right"
              @click="compareDocDetailsFull"
              elevation="0"
            >
              <v-icon>mdi-compare</v-icon> Compare</v-btn
            >
          </template>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        v-if="definitionChanged > 0 && internalViewData && internalViewDef"
        ><v-col>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <TableColumnHeaders
                :dataColumns="detailColumnsUsed"
                :preColumns="[]"
                :postColumns="['']"
                :rows="documents"
                :stateKey="stateKey"
                :presetFilters="internalViewDef.columnFilters"
                :useJATheme="true"
                @sortby="setSort($event)"
                @filterApplied="applyColumnFilters($event)"
              ></TableColumnHeaders>
              <tbody @wheel.stop="wheelVScroll($event)">
                <tr
                  v-for="(d, di) in pageRows"
                  :key="'d' + d.level + '_' + d.detail.doc_id + '_' + di"
                  :class="d.cssClassRow"
                  :style="
                    d.expanded
                      ? 'cursor: zoom-out;'
                      : d.hasChildren
                      ? 'cursor: zoom-in;'
                      : ''
                  "
                >
                  <template
                    v-if="
                      internalViewDef.viewType === 'similarity' && !d.parentKey && internalViewDef.showSimilarityTitleRow
                    "
                  >
                    <td
                      class="row-cell first-column"
                      :class="di === pageRows.length - 1 ? ' last-row' : ''"
                      :style="getCellStyle(d, 0)"
                      @click="toggleShow(d)"
                    >
                      <v-icon
                        class="mx-2"
                        color="black"
                        style="font-size: 20px"
                        >{{
                          d.expanded ? "mdi-chevron-down" : "mdi-chevron-right"
                        }}</v-icon
                      >
                      <CheckBox
                        class="mr-2"
                        style="display: inline-block; vertical-align: sub"
                        :item="d"
                        @click="selectDocument(d)"
                      ></CheckBox>
                      <span>{{
                        d.detail.detail
                          ? d.detail.detail.doc_name
                          : d.detail.doc_name
                      }}</span>
                    </td>
                    <td
                      :colspan="detailColumnsUsed.length"
                      class="row-cell last-column"
                      :class="di === pageRows.length - 1 ? ' last-row' : ''"
                      @click="toggleShow(d)"
                    >
                      <v-icon class="mx-2" color="#FFCB00" small
                        >mdi-alert</v-icon
                      >
                      <span v-html="getMatchDescription(d)"></span>
                    </td>
                  </template>
                  <template v-else>
                    <td
                      v-for="(c, ci) in detailColumnsUsed"
                      :key="'d' + d.detail.doc_id + 'c' + ci"
                      @click="toggleShow(d)"
                      class="row-cell"
                      :class="
                        d.cssClassColumns[ci] +
                        (di === pageRows.length - 1 ? ' last-row' : '')
                      "
                      :style="getCellStyle(d, ci, c)"
                    >
                      <template v-if="ci === 0 && d.hasChildren">
                        <v-icon class="mx-2" color="black">{{
                          d.expanded ? "mdi-chevron-down" : "mdi-chevron-right"
                        }}</v-icon>
                        <CheckBox
                          class="mr-2"
                          style="display: inline-block; vertical-align: sub"
                          :item="d"
                          @click="selectDocument(d)"
                        ></CheckBox>
                          <v-avatar
                            v-if="ci === 0 && !!internalViewDef.showMatchScores && d.detail.match_pct_content"
                            :color="(internalViewDef.showLinkSimilarityColours && d.detail.match_pct_content_colour ? d.detail.match_pct_content_colour : null) || 'teal'"
                            size="25"
                            class="mr-2"
                          >
                            <span class="white--text" style="font-size: 12px">{{
                              Number.parseFloat(d.detail.match_pct_content).toFixed()
                            }}</span>
                          </v-avatar>
                        <div
                          style="
                            max-width: calc(100% - 80px);
                            display: -webkit-inline-box;
                          "
                        >
                          <span>{{
                            d.detail.detail
                              ? d.detail.detail[c.value]
                              : d.detail[c.value]
                          }}</span>
                          <span class="instance-count ml-2">{{
                            d.childCount
                          }}</span>
                        </div>
                      </template>
                      <template v-else>
                        <DocStatus
                          v-if="c.value === 'doc_status_text'"
                          :document="d.detail.detail ? d.detail.detail : d.detail"
                          sideAddendum
                        ></DocStatus>
                        <div v-else>
                          <CheckBox
                            v-if="ci === 0"
                            class="mr-2"
                            style="display: inline-block; vertical-align: sub"
                            :item="d"
                            @click="selectDocument(d)"
                          ></CheckBox>
                          <v-avatar
                            v-if="ci === 0 && !!internalViewDef.showMatchScores && d.detail.match_pct_content"
                            :color="(internalViewDef.showLinkSimilarityColours && d.detail.match_pct_content_colour ? d.detail.match_pct_content_colour : null) || 'teal'"
                            size="25"
                            class="mr-2"
                          >
                            <span class="white--text" style="font-size: 12px">{{
                              Number.parseFloat(d.detail.match_pct_content).toFixed()
                            }}</span>
                          </v-avatar>
                          <div v-if="ci === 0" style="
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
    vertical-align: middle;
  width: calc(100% - 80px);" :title=" d.detail.detail
                              ? d.detail.detail[c.value]
                              : d.detail[c.value]">
                          {{
                            d.detail.detail
                              ? d.detail.detail[c.value]
                              : d.detail[c.value]
                          }}</div>
                          <template v-else>
                          {{
                            d.detail.detail
                              ? d.detail.detail[c.value]
                              : d.detail[c.value]
                          }}
                          </template>
                          </div
                        >
                      </template>
                    </td>
                    <td
                      class="last-column"
                      :class="di === pageRows.length - 1 ? 'last-row' : ''"
                    >
                      <DocSummary
                        :doc_id="d.detail.doc_id"
                        icon altLayout
                        @openDocument="openDocument"
                        @copyDocument="$emit('copyDocument', $event)"
                      ></DocSummary>
                      <!-- <v-icon>mdi-dots-horizontal</v-icon> -->
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-simple-table> </v-col
        ><v-col
          :style="{ height: vScroll.pageHeight + 'px' }"
          style="
            overflow: auto;
            margin-top: 50px;
            margin-left: -10px;
            max-width: 20px;
          "
          ref="scrollContainer"
          @scroll="setVScroll_"
        >
          <div
            ref="scrollBar"
            :style="{ height: vScroll.maxHeight, width: '1px' }"
          ></div> </v-col
      ></v-row>
    </v-container>
    <v-dialog v-model="sideBySide.show" style="max-height: 93%;">
      <DocumentSideBySide
        v-if="sideBySide.show"
        :items="sideBySide.items"
        :isDialogue="true"
        @close="sideBySide.show = false"
        @openContext="openContextMenu"
      ></DocumentSideBySide>
    </v-dialog>
    <DocumentCompare
      :show="fullCompareView.show"
      :compareList="fullCompareView.items"
      :highlightChanges="fullCompareView.highlightChanges"
      multiDoc
      showWorkflowActions
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
      @close="fullCompareView.show = false"
    >
    </DocumentCompare>
    <v-dialog
      v-model="tagsDialogue.show"
      :max-width="tagsDialogue.doc_ids.length === 1 ? '800px' : ''"
      scrollable
    >
      <TagCompare
        v-if="tagsDialogue.show"
        :documentIDs="tagsDialogue.doc_ids"
        :hierarchy_node_id="tagsDialogue.hierarchy_node_id"
        :tag_type_id="tagsDialogue.tag_type_id"
        :withinDialog="true"
        @close="tagsDialogue.show = false"
        @openDocument="openDocument"
        @copyDocument="$emit('copyDocument', $event)"
      ></TagCompare>
    </v-dialog>

    <DocActionsMenu
      :context="docActionsMenuContext"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocActionsMenu>

    <ResponseHandler :serviceResponse="response"></ResponseHandler>
    <!-- <Loading :isVisible="isLoading" /> -->
  </div>
</template>
  
<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
// import Pagination from "@/components/cPagination";
// import TablePagination from "@/components/common/TablePager";
import DocStatus from "@/components/common/DocStatus";
import DocumentCompare from "@/components/document/DocumentCompare";
import DocumentSideBySide from "@/components/cDocumentSideBySide.vue";
import TableColumnHeaders from "@/components/common/TableColumnHeaders";
// import TablePager from "@/components/common/TablePager";
import DocSummary from "@/components/common/DocViewPopUp";
// import SimilarityTableRow from "@/components/jobArchitecture/similarityTableRow";
import DocActionsMenu from "../common/DocActionsMenu.vue";
import TagCompare from "@/components/jobArchitecture/TagCompare";
import utils from "@/common/utils.js";
import dayjs from "dayjs";
import { mapState } from "vuex";
import jaCommon from "@/components/jobArchitecture/common.js";
import CheckBox from "@/components/jobArchitecture/CheckBox";

// let _matchDocs = [];
// let _relatedDocs = [];
const _page = "similarityAnalysis";
export default {
  name: _page,
  components: {
    ResponseHandler,
    // Pagination,
    // PageDescription,
    DocStatus,
    DocumentCompare,
    DocumentSideBySide,
    TableColumnHeaders,
    // TablePagination,
    DocSummary,
    // SimilarityTableRow,
    DocActionsMenu,
    TagCompare,
    // TablePager,
    CheckBox,
  },
  props: {
    fullScreen: { type: Boolean, required: false, default: true },
    height: { type: String, required: false, default: "" },
    ViewData: { type: Object, required: true, default: null },
    ViewDef: { type: Object, required: true, default: null },
    definitionChanged: { type: Number, required: true, default: 0 },
    usesTags: { type: Boolean, required: false, default: false },
    allowDesigner: { type: Boolean, required: false, default: false },
    allowMaximise: { type: Boolean, required: false, default: false },
    maximised: { type: Boolean, required: false, default: false },
  },
  data: function () {
    return {
      documents: [],
      internal_rows: [],
      visible_rows: [],
      similarityColumnsName: [],
      similarityColumnsContent: [],
      docStatuss: [],
      stateKey: 1,
      selectedView: null,
      docStatusList: [],
      matchLevels: [],
      detailColumnsUsed: [],
      sideBySide: { show: false, items: [] },
      fullCompareView: { show: false, highlightChanges: false, items: [] },
      sortColumn: { name: null, descending: false, isNumber: false },
      tableHeight: "700px",
      pageRows: [],
      filterList: [],
      utils: utils,
      response: null,
      docTypeIncluded: [],
      itemStatusIncluded: [],
      tempFilterText: "",
      filterText: "",
      selDoc: "",
      contextMenu: false,
      csvHeaders: [],
      dialog: false,
      defaultStatusFilterList: "approved,pre-draft,pending,draft",
      filteredItems: [],
      tableHeightTimeout: null,
      posX: null,
      posY: null,
      docActionsMenuContext: {
        show: false,
        busy: false,
        document: null,
        posX: 0,
        posY: 0,
      },
      vScroll: {
        pageHeight: 0,
        maxHeight: 0,
        doSetup: false,
        dStart: 0,
        dEnd: 0,
        dMax: 0,
        inProgress: false,
        lineHeight: 48,
        pageRows: 0,
      },
      internalViewData: null,
      internalViewDef: null,
      selectedDocs: [],
      tagsDialogue: {
        show: false,
        doc_ids: [],
        subject: "",
        hierarchy_node_id: null,
        tag_type_id: null,
      },
    };
  },
  watch: {
    ViewData(val) {
      if (val) this.initView();
    },
    definitionChanged(val) {
      if (val) this.setView();
    },
  },
  computed: {
    rowClickAction() {
      return "opendoc";
    },
    ...mapState({
      isLoading: (state) => state.docs.loading,
      hierarchyTypes: (state) => state.docs.hierarchyTypes,
      documentTypes: (state) =>
        state.docs.docTypeSummary.filter((x) => x.tmpl_id),
      docStatusSummary: (state) => state.docs.docStatusSummary,
      detailColumns: (state) =>
        state.docs.docListColumns.filter((c) => c.showInListView),
    }),
  },
  created() {
    this.initView();
    this.$nextTick(() => {
      this.setTableHeight();
      this.setView();
    });
  },
  methods: {
    onPaneResize() {
      if (this.tableHeightTimeout) {
        clearTimeout(this.tableHeightTimeout);
        this.tableHeightTimeout = null;
      }
      this.tableHeightTimeout = setTimeout(() => this.setTableHeight(), 50);
    },
    setTableHeight() {
      if (!this.$refs.table_container) return;
      const pos = this.$refs.table_container.getBoundingClientRect();
      let availableHeight = window.innerHeight - pos.top - 120; // for header and footer
      if (this.ViewDef?.description) availableHeight -= 50;
      if (availableHeight < 250) availableHeight = 250;
      this.tableHeight = `${availableHeight}px`;
      this.vScroll.pageRows = Math.floor(
        availableHeight / this.vScroll.lineHeight
      );
      this.vScroll.pageHeight = this.vScroll.pageRows * this.vScroll.lineHeight;
      this.vScroll.dStart = 0;
    },
    setVScroll_(event) {
      if (event.target.closest(".resizable-component")) return;
      if (this.vScroll.inProgress) {
        this.vScroll.inProgress = false;
        return;
      }
      let sl = this.$refs.scrollContainer.scrollTop;
      let max = this.$refs.scrollContainer.scrollHeight;
      let start = 0;
      if (sl > 0) {
        start = parseInt((this.vScroll.dMax * sl) / max);
      }
      if (start !== this.vScroll.dStart) {
        this.vScroll.dStart = start;
        this.pageChanged();
      }
    },
    setVScrollMax(rowCount) {
      this.vScroll.dMax = rowCount;
      const rowHeight = this.vScroll.lineHeight;
      this.vScroll.maxHeight = rowCount * rowHeight + "px";
    },
    documentChanged(doc) {
      this.$store.dispatch("docs/updateDoc", doc);
      this.filterMatches();
    },
    formatDate(value) {
      return value ? dayjs(value).format("D MMM YYYY") : "";
    },
    parseDate(date) {
      if (!date) return null;
      return dayjs(date).format("YYYY-MM-DD");
    },
    initView() {
      this.internalViewDef = this.ViewDef;
      this.internalViewData = this.ViewData;
      this.matchLevels = this.internalViewData.matchLevels;
      this.docStatuss = this.internalViewData.docStatuss;
      this.similarityColumnsName = this.internalViewData.similarityColumnsName;
      this.similarityColumnsContent = this.internalViewData.similarityColumnsContent;
      // this.setView();
    },
    setView() {
      this.internalViewDef = this.ViewDef;
      jaCommon.changeSimDocType(this.internalViewDef, this.internalViewData);
      this.setColumns();
      this.filterMatches();
    },
    filterMatches(sameState) {
      if (!sameState) this.stateKey++;
      let matchLevelsUsed = this.matchLevels.filter((m) =>
        this.internalViewDef.matchLevels.some((i) => i === m.name)
      );
      let view = this.internalViewDef;
      let statuses = view.statuses;
      // let sourceDocs = view.linked_doc_view ? _relatedDocs : _matchDocs;
      let sourceDocs = this.internalViewData.documents.filter(x => view.linked_doc_view ? x.relationships.length : x.matches.length)
      let columnFilters = view.columnFilters
        ? view.columnFilters
            .filter((f) => f.filterSettings.isActive)
            .map((f) => {
              let cf = {
                column: f.value,
                name: f.text,
                values: f.filterSettings.values
                  .filter((v) => v.selected)
                  .map((v) => v.value),
              };
              cf.title = `${cf.name} = [${cf.values.join(", ")}]`;
              return cf;
            })
        : [];
      this.filterList = JSON.parse(JSON.stringify(columnFilters));
      let maxPctFilterIndex = columnFilters.findIndex(
        (f) => f.column === "match_pct_content_max"
      );
      let maxPctFilter =
        maxPctFilterIndex >= 0 ? columnFilters[maxPctFilterIndex] : null;
      if (columnFilters.length) {
        if (maxPctFilterIndex >= 0) {
          // can't apply this filter until value is derived below
          columnFilters.splice(maxPctFilterIndex, 1);
        }
        sourceDocs = sourceDocs.filter((x) => {
          return columnFilters.every((f) =>
            f.values.some((v) => x[f.column] === v)
          );
        });
      }
      let documents;
      if (view.linked_doc_view) {
        documents = sourceDocs.filter(
          (d) =>
            view.templates.some((t) => t === d.tmpl_id) &&
            statuses.some((s) => s === d.doc_status_text)
        );
      } else {
        this.matchDocType = this.documentTypes.find(x => x.tmpl_id === view.tmpl_id).docType;
        this.matchName = this.internalViewDef.name_match !== "ignore_name" ? 
          this.ViewData.similarityColumnsName.find(
            (x) => x.column === this.internalViewDef.name_match
          )?.label : null;
        this.matchContent = this.internalViewDef.content_match !== "ignore_content" ? 
          this.ViewData.similarityColumnsContent.find(
            (x) => x.column === this.internalViewDef.content_match
          )?.label : null;
        this.matchLevelsUsed = matchLevelsUsed;

        documents = sourceDocs.filter(
          (d) =>
            d.tmpl_id === view.tmpl_id &&
            statuses.some((s) => s === d.doc_status_text)
        );
      }
      let listColumn = view.linked_doc_view ? "relationships" : "matches";
      const matchTypes = [];
      if (!view.linked_doc_view) {
        if (view.name_match !== "ignore_name") matchTypes.push(view.name_match);
        if (view.content_match !== "ignore_content") matchTypes.push(view.content_match);
      }
      documents.forEach((d) => {
        if (d[listColumn]) {
          d.filteredItems = d[listColumn].filter(
            (dm) =>
              (view.linked_doc_view ||
                statuses.some((s) => s === dm.detail.doc_status_text)) &&
              jaCommon.filterLinkedRow(matchLevelsUsed, matchTypes, d, dm)
          );
          let match_pct_content_max = Number(
            d.filteredItems.reduce((p, c) => {
              return p < c.match_pct_content ? c.match_pct_content : p;
            }, 0)
          );
          d.match_pct_content_max = match_pct_content_max.toFixed();
          if (view.linked_doc_view) {
            const setLinkedDocs = (docs) => {
              docs.filter(x => x.detail).forEach((ld) => {
                ld.filteredItems = ld.detail[listColumn].filter((dm) =>
                  jaCommon.filterLinkedRow(matchLevelsUsed, matchTypes, ld.detail, dm)
                );
                setLinkedDocs(ld.filteredItems);
              });
            };
            setLinkedDocs(d.filteredItems);
          }
        }
        d.expanded = false;
      });
      this.documents = documents.filter((d) => d.filteredItems.length);
      if (maxPctFilter)
        this.documents = documents.filter((d) =>
          maxPctFilter.values.some((v) => d[maxPctFilter.column] === v)
        );
      this.setupInternalRows();
      this.setVisibleRows();
      this.pageChanged(0);
    },
    setupInternalRows() {
      let internal_rows = [];
      let addRows = (rows, level, parentKey) => {
        rows.forEach((r, ri) => {
          const key = `${parentKey ? parentKey + "_" : ""}${r.doc_id}`;
          internal_rows.push({
            level: level,
            detail: r,
            key: key,
            parentKey: parentKey,
            hasChildren: !!r.filteredItems?.length,
            childCount: r.filteredItems?.length || 0,
            expanded: false,
            selected: false,
            visible: level === 0,
            index: ri,
            visibleChildren: 0,
            cssClassRow: level > 0 ? "sub-row" : "",
            cssClassColumns: this.detailColumnsUsed.map((c, ci) =>
              ci === 0
                ? "first-column"
                : ci === this.detailColumnsUsed.length - 1
                ? ""
                : ""
            ),
          });
          if (r.filteredItems) {
            addRows(r.filteredItems, level + 1, key);
          }
        });
      };
      addRows(this.documents, 0, null);
      this.internal_rows = internal_rows;
    },
    setVisibleRows() {
      this.visible_rows = this.internal_rows.filter((x) => x.visible);
      this.sort();
      this.setVScrollMax(this.visible_rows.length);
    },
    getCellStyle(row, colIndex, col) {
      if (colIndex !== 0) return null;
      let width = "320px";
      if (col) {
        switch(col.value) {
          case "doc_name":
            width = "420px";
            break;
          case "system_number":
            width = "220px";
            break;
        }
      }
      return colIndex === 0
        ? {
            paddingLeft: row.level * 40 + "px",
            minWidth: width,
          }
        : null;
    },
    sort() {
      if (this.sortColumn.name) {
        const col = this.sortColumn.name;
        const isNum = this.sortColumn.isNumber;
        const dir = this.sortColumn.descending ? -1 : 1;
        const setSortKey = (rows, parent) => {
          rows.forEach((r) => {
            r.sortKey =
              (parent?.sortKey || "") +
              (isNum
                ? r.detail[col] || 0
                : r.detail[col]?.toLowerCase().trim() || "");
            if (r.expanded) {
              setSortKey(
                this.visible_rows.filter(
                  (x) => x.level === r.level + 1 && x.parentKey === r.key
                ),
                r
              );
            }
          });
        };
        setSortKey(this.visible_rows.filter((x) => x.level === 0));
        this.visible_rows.sort(
          (a, b) =>
            dir * (a.sortKey > b.sortKey ? 1 : a.sortKey < b.sortKey ? -1 : 0)
        );
      }
    },
    setSort(column) {
      this.sortColumn = column;
      this.setVisibleRows();
      this.pageChanged(0);
    },
    applyColumnFilters(filters) {
      this.internalViewDef.columnFilters = filters;
      this.filterMatches(filters.some((f) => f.filterSettings.isActive));
    },
    removeColumnFilter(f) {
      let lvfilter = this.internalViewDef.columnFilters.find(
        (x) => x.value === f.column
      );
      if (lvfilter) {
        lvfilter.filterSettings.values.forEach((x) => {
          x.selected = false;
          x.applied = false;
        });
        lvfilter.filterSettings.isActive = false;
        this.filterMatches();
      }
    },
    toggleShow(row) {
      if (!row.childCount) return;
      row.expanded = !row.expanded;
      const show = row.expanded;
      row.cssClassRow = show
        ? row.cssClassRow + " row-expanded"
        : row.cssClassRow.replace(" row-expanded", "");
      const showChildren = (key, show) => {
        this.internal_rows
          .filter((x) => x.parentKey === key && x.visible !== show)
          .forEach((x) => {
            x.visible = x.expanded && show ? true : show;
            showChildren(x.key, show && x.expanded);
          });
      };
      showChildren(row.key, show);
      this.setVisibleRows();
      const countOpenChildren = (row, level) => {
        let directChildren = this.visible_rows.filter(
          (x) => x.parentKey === row.key && x.level === level
        );
        let count = directChildren.length;
        directChildren.forEach((c, ci) => {
          countOpenChildren(c, level + 1);
          if (ci < directChildren.length - 1) count += c.visibleChildren;
        });
        row.visibleChildren = count;
      };
      this.visible_rows
        .filter((r) => r.level === 0)
        .forEach((r) => {
          countOpenChildren(r, 1);
        });
      this.showCurentPage();
    },
    selectDocument(row) {
      row.selected = !row.selected;
      if (row.selected) this.selectedDocs.push(row);
      else {
        const index = this.selectedDocs.findIndex((x) => x.detail.doc_id === row.detail.doc_id);
        if (index >= 0)
          this.selectedDocs.splice(index, 1);
      }
    },
    compareDocDetailsFull() {
      this.fullCompareView.show = true;
      this.fullCompareView.items = this.selectedDocs.map((dm) => {
        return {
          doc_id: dm.doc_id || dm.detail.doc_id,
          doc_name: dm.doc_name || dm.detail.doc_name,
          match_pct_name: dm.match_pct_name,
          match_pct_content: dm.match_pct_content,
        };
      });
    },
    compareDocDetails() {
      this.sideBySide.show = true;
      this.sideBySide.items = this.selectedDocs.map((dm) => {
        return {
          doc_id: dm.doc_id || dm.detail.doc_id,
          system_number: dm.detail.system_number,
          doc_name: dm.doc_name || dm.detail.doc_name,
        };
      });
    },
    resetCompare() {
      this.selectedDocs.splice(0, this.selectedDocs.length);
      this.internal_rows.forEach((x) => (x.selected = false));
    },
    getMatchDescription(doc) {
      let desc = `      
        <span class="similarity-label mx-2"
          >${doc ? doc.childCount : ""} ${this.matchDocType}s</span
        >with`;
      if (this.matchName)
        desc += `<span class="similarity-label mx-2">${this.matchName}</span>`;
      if (this.matchName && this.matchContent)
        desc += `and`;
      if (this.matchContent)
        desc += `<span class="similarity-label mx-2">${this.matchContent}</span>`;
      if (this.matchLevelsUsed?.length) {
        desc += this.matchLevelsUsed.map(l => 
        `and<span class="similarity-label mx-2">${l.name}</span>`).join("");
      }
      return desc;
    },
    getDocumentTags() {
      if (this.selectedDocs.length) {
        this.tagsDialogue.doc_ids = this.selectedDocs.map(
          (x) => x.doc_id || x.detail.doc_id
        );
        this.tagsDialogue.hierarchy_node_id = null;
        this.tagsDialogue.show = true;
        return;
      }
    },
    wheelVScroll(data) {
      if (data && data.deltaY !== 0) {
        if (data.deltaY > 0 && this.vScroll.dEnd < this.vScroll.dMax) {
          this.vScroll.dStart++;
          this.vScroll.dEnd++;
          this.pageChanged();
        } else if (data.deltaY < 0 && this.vScroll.dStart > 0) {
          this.vScroll.dStart--;
          this.vScroll.dEnd--;
          this.pageChanged();
        } else {
          return;
        }
      }
    },
    pageChanged(start) {
      if (start === undefined) start = this.vScroll.dStart;
      if (start < 0) start = 0;
      if (start >= this.vScroll.dMax - 1)
        start = this.vScroll.dMax - this.vScroll.pageRows;
      this.vScroll.dStart = start;
      this.vScroll.dEnd = start + this.vScroll.pageRows;

      if (this.$refs.scrollContainer) {
        let max = this.$refs.scrollContainer.scrollHeight;
        this.$refs.scrollContainer.scrollTop =
          (max * this.vScroll.dStart) / this.vScroll.dMax;
      }

      this.showCurentPage();
    },
    showCurentPage() {
      this.pageRows = this.visible_rows.slice(
        this.vScroll.dStart,
        this.vScroll.dEnd
      );
    },
    setColumns() {
      this.detailColumnsUsed = this.detailColumns.filter((x) =>
        this.internalViewDef.columnsVisible.some((c) => c === x.value)
      );
      this.stateKey++;
    },
    getDocTypeFilterText(item, index) {
      if (item && index > 0) return "";
      if (this.docTypeIncluded.length === this.docTypeSummary.length)
        return this.docTypeSummary.length > 0 ? "All" : "None";

      if (this.docTypeIncluded.length > 2)
        return `${this.docTypeIncluded.length} items`;

      return this.docTypeIncluded.map((i) => i.docType).join(", ");
    },
    getStatusFilterText(item, index) {
      if (item && index > 0) return "";
      if (this.docStatusIncluded.length === this.docStatusSummary.length) {
        return this.docStatusSummary.length > 0 ? "All" : "None";
      } else {
        let defList = this.defaultStatusFilterList.split(",");
        if (
          defList.every((s) =>
            this.docStatusIncluded.some((si) => si.status.toLowerCase() === s)
          )
        ) {
          let text = "";
          text = "Default";
          if (defList.length < this.docStatusIncluded.length) {
            text += ` (+ ${this.docStatusIncluded.length - defList.length})`;
          }
          return text;
        } else {
          return this.docStatusIncluded.reduce((prev, curr) => {
            return prev + (prev ? ", " : "") + curr.status;
          }, "");
        }
      }
    },
    selectRow(event, item) {
      if (this.rowClickAction === "menu") {
        this.openContextMenu(event, item);
      } else {
        this.openDocument(item);
      }
    },
    openDocument(item) {
      this.contextMenu = false;
      this.$emit("openDocument", item);
    },
    exportToCSV() {
      this.csvHeaders = JSON.parse(
        JSON.stringify(
          this.detailColumnsUsed.filter(
            (x) => x.value !== "match_pct_content_max"
          )
        )
      );
      let childType = this.internalViewDef.linked_doc_view
        ? "LINKED"
        : "MATCHED";
      let data =
        '"Relationship","Match Group","Match Group Row",' +
        this.csvHeaders.map((h) => '"' + h.text + '"').join(",") +
        (this.internalViewDef.linked_doc_view ? "" : ',"Match Percent"') +
        "\n";
      this.documents.forEach((d, di) => {
        data +=
          '"MAIN DOCUMENT","' +
          (di + 1) +
          '","0",' +
          this.csvHeaders
            .map((h) => utils.csvEscape(utils.removeTags(d[h.value])))
            .join(",") +
          (this.internalViewDef.linked_doc_view ? "" : ",") +
          "\n";
        d.filteredItems.forEach((i, ii) => {
          data +=
            '"' +
            childType +
            ' DOCUMENT","' +
            (di + 1) +
            '","' +
            (ii + 1) +
            '",' +
            this.csvHeaders
              .map((h) => utils.csvEscape(utils.removeTags(i.detail[h.value])))
              .join(",") +
            (this.internalViewDef.linked_doc_view
              ? ""
              : "," + Number.parseFloat(i.match_pct_content).toFixed() + "") +
            "\n";
        });
      });
      utils.downloadFile(
        data,
        `${this.selectedView}.csv`,
        "text/csv;encoding:utf-8"
      );
    },
    openContextMenu(event, document) {
      event.preventDefault();
      let doc = { doc_id: document.doc_id };
      this.docActionsMenuContext.document = doc;
      this.docActionsMenuContext.posX = event.clientX;
      this.docActionsMenuContext.posY = event.clientY;
      this.docActionsMenuContext.show = false;
      this.$nextTick(() => {
        this.docActionsMenuContext.show = true;
      });
    },
  },
};
</script>
  <style lang="scss" scoped>
@import "@/assets/styles/vars";

.filter-col {
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 50%;
  @media (min-width: 960px) {
    max-width: 25%;
  }
  @media (min-width: 1264px) {
    max-width: 14%;
  }
}

.btn-background {
  height: 44px;
  ::v-deep .v-input__slot {
    background: transparent !important;
  }
}

::v-deep .v-select__selections {
  overflow: hidden;
  white-space: nowrap;
  flex-flow: nowrap;
}

th.tf {
  border: 1px solid #d9d9d9;
  background-color: #eeeeee !important;
}
th.th {
  font-weight: bold;
  text-transform: uppercase;
}
th.tf {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
tfoot tr {
  position: sticky;
  bottom: 0;
}
</style>
  <style lang="scss">
.similarity-label {
  background-color: #eeeeee;
  color: black;
  font-weight: 700;
  font-size: 14px;
  font-family: "DM Sans" !important;
  border-radius: 8px;
  padding: 2px 8px;
  height: 22px;
}
  </style>
  